import { sideBarToggle } from "./utils";
import MobileMenu from "./MobileMenu";
import { useEffect, useState } from "react";
import Menu from "./Menu";
import "../Main.css";
import SideBar from "./SideBar";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
const Header = () => {
  return (
    <>
      <Header1 />

    </>
  );
};
export default Header;

const Header1 = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;


      const scrollThreshold = 100;


      setScrolled(scrollTop > scrollThreshold);
    };


    window.addEventListener("scroll", handleScroll);


    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const isPressPage = location.pathname === "/press-release";
  // const isCaseStudiesPage = location.pathname === "/case-studies";

  return (
    <header
      className={`main-header header-two ${scrolled ? "fixed-header" : ""} ${isPressPage ? "press-header" : "Color:white"
        }`}

    >

      <div className="header-upper">
        <div className="container clearfix">
          <div className="header-inner rel d-flex align-items-center justify-content-between">
            <div className="logo-outer">
              <div className="logo">
                <Link to="/">

                  <img
                    src="/assets/tth_logo.png"
                    alt="Logo"
                    title="Logo"
                    style={{ height: "45px", width: "auto" }}
                  />

                </Link>
              </div>
            </div>
            <div className="nav-outer clearfix mx-0">
              <MobileMenu logo={"/images/logos/logo-two.png"} />

              <nav className="main-menu d-none d-lg-block navbar-expand-lg">
                <div className="navbar-header">
                  <div className="mobile-logo my-15">
                    <a href="/">

                      <img
                        src="/images/logos/logo-two.png"
                        alt="Logo"
                        title="Logo"
                      />

                    </a>
                  </div>

                  <button
                    type="button"
                    className="navbar-toggle"
                    data-bs-toggle="collapse"
                    data-bs-target=".navbar-collapse"
                  >
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                  </button>
                </div>
                <div className="navbar-collapse collapse clearfix">
                  <Menu />
                </div>
              </nav>

            </div>
            <div className="menu-btns">
              <div className="menu-sidebar d-none d-lg-block">
                <button onClick={() => sideBarToggle()}>
                  <span
                    className="icon-bar"
                    style={{ backgroundColor: "#000" }}
                  />
                  <span
                    className="icon-bar"
                    style={{ backgroundColor: "#000" }}
                  />
                  <span
                    className="icon-bar"
                    style={{ backgroundColor: "#000" }}
                  />
                </button>
                <SideBar />
              </div>
            </div>
          </div>
        </div>
      </div>

    </header>
  );
};
